type SolutionsRegulatoryContextProps = {
  label?: string
  text: string
  linkLabel?: string
  linkHref?: string
}

const SolutionsRegulatoryContext = ({
  label = 'Regulatory Context',
  text,
  linkLabel,
  linkHref,
}: SolutionsRegulatoryContextProps) => {
  return (
    <section className="bg-brand-blue/10 border-0 border-l-4 border-solid border-brand-blue py-10">
      <div className="mx-auto max-w-5xl px-6 lg:px-8 flex flex-col gap-3">
        <span className="text-xs font-semibold uppercase tracking-widest text-brand-blue">
          {label}
        </span>
        <p className="text-lg font-light italic text-brand-navy leading-relaxed">{text}</p>
        {linkLabel && linkHref && (
          <a
            href={linkHref}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold text-brand-blue no-underline hover:underline self-start"
          >
            {linkLabel} →
          </a>
        )}
      </div>
    </section>
  )
}

export default SolutionsRegulatoryContext
